import { dark, white } from 'hfty-styles/src/colors'

export const styles = {
  outerWrapper: {
    width: '100%',
    padding: '35px 50px',
  },
  headerWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  h1: {
    margin: 0,
    color: dark(),
    fontSize: '1.4em',
  },
  h2: {
    margin: '0.5em 0 0 0',
    color: dark(0.7),
    fontSize: '0.95em',
    fontWeight: '400',
  },
  backButtonIcon: {
    transform: 'rotate(180deg)',
  },
  btnsHolder: {
    display: 'flex',
    justifyContent: 'space-evenly',
    margin: '35px 0',
  },
  btn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '250px',
    padding: 0,
    color: white(),
    boxShadow: 'none',
  },
  secondaryBtn: {
    width: '125px',
    backgroundColor: dark(),
  },
  link: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    color: white(),
    textDecoration: 'none',
  },
  icon: {
    marginRight: '2px',
  },
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    padding: '5px 0',
    marginTop: '15px',
    borderTop: `1px solid ${dark(0.2)}`,
  },
  pdfComponentWrapper: {
    display: 'inline-block',
    width: 230,
    margin: '25px 20px',
  },
  pdfImage: {
    float: 'left',
  },
  pdfImg: {
    width: 65,
  },
  pdfContent: {
    display: 'inline-block',
    paddingLeft: 5,
  },
  pdfContentLabel: {
    display: 'block',
    maxWidth: 160,
    marginBottom: 5,
    fontSize: 14,
    wordWrap: 'break-word',
    color: dark(),
  },
  pdfContentType: {
    display: 'block',
    marginBottom: 7,
    color: 'rgb(181, 181, 181)',
    fontSize: 12,
    textOverflow: 'ellipsis',
  },
  pdfContentDate: {
    display: 'block',
    color: 'rgb(181, 181, 181)',
    fontSize: 12,
  },
  errorsWrapper: {
    maxWidth: '30%',
    marginLeft: 50,
    padding: 20,
    border: '2px solid rgb(235, 175, 2)',
    borderRadius: 5,
    background: 'rgb(252, 250, 228)',
  },
  errorMessage: {
    color: 'rgb(242, 84, 103)',
    fontWeight: 500,
  },
}
